export const changeLanguage = {
  SET_LANGUAGE: 'SET_LANGUAGE',
};
